import { useState } from "react";
import { ClipboardPaste, Copy, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { copyLarge } from "@/components/sms/smsUtils";

const MODES = [
  { mode: "new", label: "Copy New", hint: "sirf jo abhi tak copy nahi hue" },
  { mode: "shown", label: "Copy Shown", hint: "is filter ke saare" },
  { mode: "all", label: "Copy All", hint: "shuru se ab tak ke saare" },
];

export const CopyBar = ({ filters, counts, onCopied, onPaste }) => {
  const [busy, setBusy] = useState("");
  const copy = async (mode) => {
    setBusy(mode);
    try {
      const body = { mode, ...filters };
      const { data } = await api.post("/sms/codes/text", body);
      if (!data.count) {
        toast.info("Copy karne ke liye kuch nahi hai");
        return;
      }
      if (!(await copyLarge(data.text))) throw new Error("Clipboard blocked");
      await api.post("/sms/codes/mark-copied", { ...body, cut_ts: data.cut_ts });
      toast.success(`${data.count.toLocaleString("en-IN")} rows copied — Sheet me Ctrl+V karo`);
      onCopied();
    } catch (e) {
      toast.error(e?.response ? formatApiError(e) : `Copy failed: ${e.message}`);
    } finally {
      setBusy("");
    }
  };
  const n = { new: counts?.new, shown: counts?.shown, all: counts?.total };
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid="sms-copy-bar">
      {MODES.map((m, i) => (
        <button key={m.mode} onClick={() => copy(m.mode)} disabled={!!busy} title={m.hint} data-testid={`sms-copy-${m.mode}`}
          className={`h-9 px-3.5 inline-flex items-center gap-1.5 rounded-full text-xs font-semibold border transition-[background-color,transform] active:scale-95 disabled:opacity-50 ${i === 0 ? "bg-[#385C4B] text-white border-[#385C4B] hover:bg-[#2C4A3C]" : "bg-white text-[#385C4B] border-[#385C4B]/40 hover:bg-[#EFEEE6]"}`}>
          {busy === m.mode ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Copy className="w-3.5 h-3.5" />}
          {m.label}
          {n[m.mode] != null && <span className="tabular-nums opacity-80">({Number(n[m.mode]).toLocaleString("en-IN")})</span>}
        </button>
      ))}
      <button onClick={onPaste} data-testid="sms-paste-open"
        className="h-9 px-3.5 inline-flex items-center gap-1.5 rounded-full text-xs font-semibold border bg-white text-[#8A6046] border-[#8A6046]/40 hover:bg-[#F6EFE8] transition-colors">
        <ClipboardPaste className="w-3.5 h-3.5" /> Paste & Save
      </button>
    </div>
  );
};
